if (!customElements.get('pincode-checker')) {
  class PincodeChecker extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-pincode-input]');
      this.result = this.querySelector('[data-pincode-result]');
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-pincode-check]')) this.check();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target === this.input) {
          event.preventDefault();
          this.check();
        }
      });
    }

    check() {
      const value = this.input.value.trim();
      this.result.classList.remove('is-success', 'is-error');
      if (!/^\d{6}$/.test(value)) {
        this.result.textContent = this.dataset.invalidMessage;
        this.result.classList.add('is-error');
        return;
      }
      this.result.textContent = this.dataset.successMessage.replace('[pincode]', value);
      this.result.classList.add('is-success');
    }
  }

  customElements.define('pincode-checker', PincodeChecker);
}
